import React, { createContext, PropsWithChildren, useContext, useState } from "react";
import { css, Global, ThemeProvider } from "@emotion/react";
import styled from "@emotion/styled";
import { MultiSelectOption } from "../../lib/interfaces";
import { FormModalProvider } from "../Modals/FormModalProvider";
import { useScrollRestoration } from "gatsby";

interface FilterContextData<T> {
  specialityValue: T[];

  onChangeSpeciality(val: T[]): void;

  clinicValue: T[];

  onChangeClinic(val: T[]): void;
}

const FilterContext = createContext<FilterContextData<MultiSelectOption> | undefined>(undefined);

export function useFilterContext() {
  const ctx = useContext(FilterContext);

  if (!ctx) {
    throw Error("Компонент находится вне контекста filter");
  }
  return ctx;
}

interface PathContextData {
  pathname: string;
}

const PathContext = createContext<PathContextData | undefined>(undefined);

export function usePath() {
  const ctx = useContext(PathContext);

  if (!ctx) {
    throw Error("Компонент находится вне контекста pathname");
  }
  return ctx.pathname;
}


const globalStyles = css`
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    box-sizing: border-box;
    color: #212129;
  }

  img {
    border-style: none;
    max-width: 100%;
    object-fit: cover;
  }

  a {
    color: initial;
    text-decoration: none;
  }
`;
const theme = {
  colors: {
    primary: "#DB3170",
  },
};

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const Main = styled.main`
  display: grid;
  flex-grow: 1;
`;

function Layout({ location, children }: PropsWithChildren<any>) {
  let [ speciality, setSpeciality ] = useState<MultiSelectOption[]>([]);
  let [ clinics, setClinics ] = useState<MultiSelectOption[]>([]);
  const ulScrollRestoration = useScrollRestoration(`page-component-ul-list`);

  const changeFilter = (setFunc: (value: MultiSelectOption[]) => void, value: MultiSelectOption[]) => {
    window?.scrollTo(0, 0);
    setFunc(value);
  };

  const filterOptions = {
    specialityValue: speciality,
    onChangeSpeciality: (value: MultiSelectOption[]) => changeFilter(setSpeciality, value),
    clinicValue: clinics,
    onChangeClinic: (value: MultiSelectOption[]) => changeFilter(setClinics, value),
  };

  return <ThemeProvider theme={ theme }>
    <FormModalProvider>
      <PathContext.Provider value={ { pathname: location.pathname } }>
        <FilterContext.Provider value={ filterOptions }>
          <Global styles={ globalStyles }/>
          <Wrapper>
            { children }
          </Wrapper>
        </FilterContext.Provider>
      </PathContext.Provider>
    </FormModalProvider>
  </ThemeProvider>;
}

export default Layout;